angular
    .module('app')
    .component('winbackOffersEdit', {
        templateUrl: '/templates/pages/winback-offers/winback-offers-edit/winback-offers-edit.html',
        controller: 'WinbackOffersEditController',
        controllerAs: 'vm',
    });